module.exports = __webpack_public_path__ + "static/media/Glands.6812010b.ogg";